import apiClient from 'services/_infra/apiClient';
import { tryCache } from 'services/_infra/requestCache';
import { loginfo } from 'services/_infra/util/apiUsageLogger';

export async function getGlobalActions() {
  try {
    const res = await tryCache('getGlobalActions', () => apiClient.get('/getGlobalActionsByWPId/'));
    return res;
  } catch (error) {
    console.error('getGlobalActionsByWPId failed.', error);
  }
}

export async function insertGlobalAction(action) {
  try {
    loginfo();
    return await apiClient.post('/insertGlobalActions', {
      globalAction: action,
    });
  } catch (error) {
    console.error('insertGlobalActions failed.', error);
  }
}

export async function updateGlobalAction(id, action) {
  try {
    loginfo();
    return await apiClient.post('/updateGlobalActions', {
      globalAction: action,
      globalActionId: id,
    });
  } catch (error) {
    console.error('updateGlobalActions failed.', error);
  }
}

export async function setGlobalActionEnabled(id, status) {
  try {
    loginfo();
    return await apiClient.post('/setGlobalActionEnabled', {
      id,
      status,
    });
  } catch (error) {
    console.error('setGlobalActionEnabled failed.', error);
  }
}

export async function deleteGlobalAction(actionId) {
  try {
    loginfo();
    return await apiClient.post('/delGlobalActions', {
      globalActionId: actionId,
    });
  } catch (error) {
    console.error('delGlobalActions failed.', error);
  }
}
